import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireRouteAccess } from '@/lib/routeGuards';
export const Route = createFileRoute('/_authed/admin/mock-exams')({
  beforeLoad: () => requireRouteAccess('/admin/mock-exams'),
  component: Outlet,
});
